import MainLayout from 'layout/MainLayout';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import { AccountingProtectedRoute } from './DepartmentProtect';
import ProtectedRoute from './ProtectedRoutes';


const PaymentHistory = Loadable(lazy(() => import('views/pages/accounting/PaymentHistory')));
const Expenditures = Loadable(lazy(() => import('views/pages/accounting/Expenditures')));
const AccountingDashboardPage = Loadable(lazy(() => import('views/pages/accounting')));
const AccountingInvoicesPage = Loadable(lazy(() => import('views/pages/accounting/Invoices')));
const AccountingReports = Loadable(lazy(() => import('views/pages/accounting/Analytics')));
const AccountingCertificates = Loadable(lazy(() => import('views/pages/accounting/Certificates')));
const CertificateDetailPage = Loadable(lazy(() => import('views/pages/qs/CertificateDetailPage')));
const AccountingPaymentsPage = Loadable(lazy(() => import('views/pages/accounting/Payments')));
const TransfersPage = Loadable(lazy(() => import('views/pages/accounting/Transfers')));
const AccountSettings = Loadable(lazy(() => import('ui-component/account-settings')));
const AuditLogsPage = Loadable(lazy(() => import('views/pages/dashbord/utilities/AuditLog')));
const AccProjectsList = Loadable(lazy(() => import('views/pages/accounting/AccProjectList')));
const AccProjectDetail = Loadable(lazy(() => import('views/pages/accounting/AccProjectDetails')));
const AccMemberProfile = Loadable(lazy(() => import('views/pages/accounting/AccMemberProfile')));
const AccTeamPage = Loadable(lazy(() => import('views/pages/accounting/AccTeam')));
const InvoiceDetailPage = Loadable(lazy(() => import('views/pages/procurement/InvoiceDetails')));

// ==============================|| MAIN ROUTING ||============================== //

const AccountingRoutes = {
    path: '/accounting',
    element: (
        <AccountingProtectedRoute>
            <MainLayout />
        </AccountingProtectedRoute>
    ),
    children: [
        {
            path: '/accounting',
            element: <Navigate to="/accounting/dashboard" replace />
        },
        {
            path: '/accounting/dashboard',
            element: <AccountingDashboardPage />
        },
        {
            path: '/accounting/invoices',
            element: <AccountingInvoicesPage />
        },
        {
            path: '/accounting/invoices/:id',
            element: <InvoiceDetailPage />
        },
        {
            path: '/accounting/reports',
            element: <AccountingReports />
        },
        {
            path: '/accounting/certificates',
            element: <AccountingCertificates />
        },
        {
            path: '/accounting/certificates/:id',
            element: (
                <ProtectedRoute
                    permissions={['certificates.read', 'certificates.update', 'certificates.review_qs', 'certificates.approve_qs']}
                >
                    <CertificateDetailPage />
                </ProtectedRoute>
            )
        },
        {
            path: '/accounting/payments',
            element: <AccountingPaymentsPage />
        },
        {
            path: '/accounting/expenditures',
            element: <Expenditures />
        },
        {
            path: '/accounting/payments-history',
            element: <PaymentHistory />
        },
        {
            path: '/accounting/transfers',
            element: <TransfersPage />
        },
        {
            path: '/accounting/projects/:sectorId/:slug',
            element: <AccProjectsList />
        },

        {
            path: '/accounting/projects/:id',
            element: (
                <ProtectedRoute permissions={['projects.read']}>
                    <AccProjectDetail />
                </ProtectedRoute>
            )
        },
        {
            path: '/accounting/team',
            element: <AccTeamPage />
        },
        {
            path: '/accounting/team/:id',
            element: <AccMemberProfile />
        },
        {
            path: '/accounting/account_settings',
            element: <AccountSettings />
        },
        {
            path: '/accounting/audit-logs',
            element: <AuditLogsPage />
        }
    ]
};

export default AccountingRoutes;
